import { useTranslation } from "react-i18next";
import { GraduationCap, UsersThree, Network } from "@phosphor-icons/react";

export const Pillars = () => {
  const { t } = useTranslation();

  const pillars = [
    {
      icon: GraduationCap,
      title: t("pillars.p1_title"),
      desc: t("pillars.p1_desc"),
      num: "01",
    },
    {
      icon: UsersThree,
      title: t("pillars.p2_title"),
      desc: t("pillars.p2_desc"),
      num: "02",
    },
    {
      icon: Network,
      title: t("pillars.p3_title"),
      desc: t("pillars.p3_desc"),
      num: "03",
    },
  ];

  return (
    <section
      data-testid="pillars-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            {t("pillars.overline")}
          </p>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-bold tracking-tight text-slate-900 leading-[1.05]">
            {t("pillars.title")}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            {t("pillars.subtitle")}
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {pillars.map((p, i) => {
            const Icon = p.icon;
            return (
              <article
                key={i}
                data-testid={`pillar-card-${i}`}
                className="group relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_60px_-15px_rgba(15,23,42,0.12)] hover:border-slate-300"
              >
                {/* Soft gradient glow on hover */}
                <div className="pointer-events-none absolute -top-16 -right-16 h-44 w-44 rounded-full adonis-gradient opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-40" />

                <div className="flex items-start justify-between">
                  <div className="h-14 w-14 rounded-2xl bg-slate-900 flex items-center justify-center transition-transform group-hover:scale-110">
                    <Icon size={26} weight="light" className="text-white" />
                  </div>
                  <span className="font-heading text-sm font-bold tracking-tight text-slate-300">
                    {p.num}
                  </span>
                </div>

                <h3 className="mt-8 font-heading text-2xl font-bold tracking-tight text-slate-900">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {p.desc}
                </p>

                <div className="mt-8 h-px w-12 bg-slate-200 group-hover:w-24 group-hover:adonis-gradient transition-all duration-500" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Pillars;
